<template>
  <div id="enquiry" class="card-neumorphic !p-5 lg:sticky lg:top-24 relative overflow-hidden">
    <div
      v-if="isSubmitted"
      class="absolute inset-0 bg-light-purple/95 z-10 flex items-center justify-center text-white text-center p-6"
      style="border-radius: 24px"
    >
      <div>
        <p class="font-semibold text-lg mb-1">Thanks</p>
        <p class="text-sm text-white/90">WhatsApp should open — tap Send to {{ phoneDisplay }}.</p>
      </div>
    </div>

    <h2 class="text-xl font-poppins font-semibold text-dark-gray mb-1">{{ title }}</h2>
    <p class="text-sm text-dark-gray/65 mb-4">{{ subtitle }}</p>

    <form @submit.prevent="onSubmit" class="space-y-3">
      <input v-model.trim="form.name" required class="input-neumorphic !py-3 !px-4" placeholder="Your name *" />
      <input v-model.trim="form.organization" class="input-neumorphic !py-3 !px-4" placeholder="Company / Lab" />
      <input v-model.trim="form.phone" required type="tel" class="input-neumorphic !py-3 !px-4" placeholder="Phone *" />
      <input v-model.trim="form.email" type="email" class="input-neumorphic !py-3 !px-4" placeholder="Work email" />
      <textarea
        v-model.trim="form.message"
        rows="3"
        class="input-neumorphic !py-3 !px-4 resize-none"
        placeholder="What do you need?"
      />
      <p v-if="error" class="text-sm text-red-600">{{ error }}</p>
      <button
        type="submit"
        :disabled="isSubmitting"
        class="w-full btn-neumorphic !py-3 text-light-purple hover:text-white hover:bg-light-purple"
      >
        {{ isSubmitting ? 'Sending…' : cta }}
      </button>
      <p class="text-[11px] text-center text-dark-gray/50">
        Or call <a :href="`tel:${phoneTel}`" class="text-light-purple font-medium">{{ phoneDisplay }}</a>
      </p>
    </form>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import { CONTACT_PHONE_DISPLAY, CONTACT_PHONE_TEL } from '../config/contact'
import { submitForm } from '../services/submitForm'

export default {
  name: 'RichCtaCard',
  props: {
    title: { type: String, default: 'Talk to Homvisit' },
    subtitle: { type: String, default: 'Corporate camps, lab partnership, or staffing.' },
    cta: { type: String, default: 'Request callback' },
    subject: { type: String, default: 'Website enquiry' },
    sourcePage: { type: String, default: '' },
  },
  setup(props) {
    const form = reactive({
      name: '',
      organization: '',
      phone: '',
      email: '',
      message: '',
    })
    const isSubmitting = ref(false)
    const isSubmitted = ref(false)
    const error = ref('')

    const onSubmit = async () => {
      error.value = ''
      isSubmitting.value = true
      try {
        await submitForm({
          subject: props.subject,
          formName: 'Page CTA',
          data: {
            ...form,
            source_page: props.sourcePage,
            intent: 'content_page_enquiry',
          },
        })
        isSubmitted.value = true
        Object.keys(form).forEach((k) => {
          form[k] = ''
        })
        setTimeout(() => {
          isSubmitted.value = false
        }, 5000)
      } catch (e) {
        error.value = e.message || 'Could not send'
      } finally {
        isSubmitting.value = false
      }
    }

    return {
      form,
      onSubmit,
      isSubmitting,
      isSubmitted,
      error,
      phoneDisplay: CONTACT_PHONE_DISPLAY,
      phoneTel: CONTACT_PHONE_TEL,
    }
  },
}
</script>
